/**
 * Object Fit polyfill
 */
objectFitImages();
objectFitVideos();